import React, { useState, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { useAuth } from '../../../../context/AuthContext';
import SystemLoadingOverlay from './SystemLoadingOverlay';

const TrellohitSystemWrapper = ({ system, activationData, onLoaded }) => {
  const { user } = useAuth();
  const [isAppReady, setIsAppReady] = useState(false);
  const userId = user?.user_id || user?.id;

  // CRÍTICO: Calcular la URL del iframe UNA SOLA VEZ al montarse.
  // Si recalculamos en cada render, los cambios de URL del padre (vía UPDATE_PARENT_URL)
  // causan que React actualice el src del iframe, forzando una recarga del servidor
  // que no sabe resolver rutas SPA como /board/6 → 404.
  const iframeUrlRef = useRef(null);
  if (iframeUrlRef.current === null) {
    const jwtToken = localStorage.getItem('jwt_token');
    const baseUrl = activationData?.initialUrl || system.url;
    let computedUrl = baseUrl;
    if (baseUrl && userId && jwtToken) {
      try {
        const urlObj = new URL(baseUrl);

        // Extract internal route from parent path only if we are currently viewing this system
        let internalRoute = '';
        if (window.location.pathname.startsWith('/systems/proyectos')) {
          internalRoute = window.location.pathname.replace(/^\/systems\/proyectos/, '');
        }
        
        if (internalRoute && internalRoute !== '/') {
          const cleanBase = urlObj.pathname.replace(/\/$/, '');
          const cleanRoute = internalRoute.replace(/^\//, '');
          urlObj.pathname = cleanBase + '/' + cleanRoute;
        }

        urlObj.searchParams.set('userId', String(userId));
        urlObj.searchParams.set('token', jwtToken);

        // Forward parent search parameters
        const parentParams = new URLSearchParams(window.location.search);
        parentParams.forEach((val, key) => {
          urlObj.searchParams.set(key, val);
        });

        computedUrl = urlObj.toString();
      } catch (e) {}
    }
    iframeUrlRef.current = computedUrl;
  }

  // Escuchar cuando Trellohit termina de cargar sus datos (handshake real)
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === 'TRELLOHIT_READY') {
        setIsAppReady(true);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  // Ocultar el overlay solo cuando la app está lista
  useEffect(() => {
    if (isAppReady && onLoaded) {
      onLoaded();
    }
  }, [isAppReady, onLoaded]);

  return (
    <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
      {!isAppReady && (
        <SystemLoadingOverlay
          title="Cargando Proyectos"
          subtitle="Preparando tus tableros y tareas..."
          color={system.color || '#FF6B35'}
        />
      )}
      {iframeUrlRef.current && (
        <iframe
          src={iframeUrlRef.current}
          title={system.title}
          allow="clipboard-write"
          onLoad={() => {
            // Fallback de seguridad: si no llega TRELLOHIT_READY, ocultamos igualmente
            setTimeout(() => setIsAppReady(true), 8000);
          }}
          style={{
            border: "none",
            width: "100%",
            height: "100%",
            display: "block"
          }}
        />
      )}
    </Box>
  );
};

export default TrellohitSystemWrapper;
